import { getOrgUnits } from '@web/lib/demo/utils';
export var orgUnits = function (input) {
    var orgUnits = getOrgUnits({});
    return orgUnits;
};
